import { Box } from '@mui/material';
import CompanyInformationData from './CompanyInformationData';

const CompanyInformation = ({ data }) => {
  return (
    <Box p={2} my={3} sx={{ backgroundColor: 'white', borderRadius: '8px' }}>
      <CompanyInformationData companyData={data} />
    </Box>
  );
};

export default CompanyInformation;
